<template>
    <!-- 我的钱包页面 -->
    <div class="moneybag_wrap">
        <!-- 顶部导航栏 -->
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ $t('moneybag.myWallet') }}</div>
        </div>

        <!-- 余额卡片 -->
        <div class="balance_card">
            <!-- 余额和积分 -->
            <div class="balance_info">
                <div class="balance_item">
                    <div class="balance_label">{{ $t('moneybag.accountBalance') }}</div>
                    <div class="balance_value">{{ funds }}</div>
                </div>
                <div class="balance_divider"></div>
                <div class="balance_item">
                    <div class="balance_label">可用积分</div>
                    <div class="balance_value points">{{ points }}</div>
                </div>
            </div>
            <!-- 操作按钮 -->
            <div class="action_btns">
                <div class="btn recharge" @click="$router.push('/invest')">
                    <van-icon name="add-o" />
                    <span>{{ $t('user.recharge') }}</span>
                </div>
                <div class="btn withdraw" @click="$router.push('/cash')">
                    <van-icon name="cash-on-deliver" />
                    <span>{{ $t('user.withdraw') }}</span>
                </div>
            </div>
        </div>

        <!-- 交易明细 -->
        <div class="detail_section">
            <!-- 面板切换 -->
            <div class="tab_header">
                <div class="tab_item" :class="{ active: activeTab === 'balance' }" @click="switchTab('balance')">
                    余额明细
                </div>
                <div class="tab_item" :class="{ active: activeTab === 'points' }" @click="switchTab('points')">
                    积分明细
                </div>
            </div>

            <!-- 余额明细 -->
            <template v-if="activeTab === 'balance'">
                <van-empty description="暂无余额记录" v-if="listShow" />
                <div class="detail_list" v-else>
                    <div class="detail_item" v-for="(item, index) in data" :key="index">
                        <div class="item_left">
                            <div class="item_icon" :class="item.type == '1' ? 'income' : 'expense'">
                                <van-icon :name="item.type == '1' ? 'arrow-up' : 'arrow-down'" />
                            </div>
                            <div class="item_info">
                                <div class="item_title">{{ item[lang] }}</div>
                                <div class="item_time">{{ item.time }}</div>
                            </div>
                        </div>
                        <div class="item_amount" :class="item.type == '1' ? 'income' : 'expense'">
                            {{ item.type == '1' ? '+' : '-' }}{{ item.money }}
                        </div>
                    </div>
                </div>
            </template>

            <!-- 积分明细 -->
            <template v-if="activeTab === 'points'">
                <van-empty description="暂无积分记录" v-if="pointsListShow" />
                <div class="detail_list" v-else>
                    <div class="detail_item" v-for="(item, index) in pointsData" :key="index">
                        <div class="item_left">
                            <div class="item_icon points_icon">
                                <van-icon name="gift-o" />
                            </div>
                            <div class="item_info">
                                <div class="item_title">{{ item[lang] || item.title }}</div>
                                <div class="item_time">{{ item.time }}</div>
                            </div>
                        </div>
                        <div class="item_amount" :class="item.type == '1' ? 'income' : 'expense'">
                            {{ item.type == '1' ? '+' : '-' }}{{ item.points || item.money }}
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
/**
 * 我的钱包页面组件
 * 显示账户余额、积分和交易明细列表
 * 支持余额明细和积分明细的切换查看
 */
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import { Empty, Icon } from 'vant';

Vue.use(Empty).use(Icon);

export default {
    name: "moneybag",
    /**
     * 组件数据
     * @returns {Object} 数据对象
     * @returns {string} lang - 当前语言
     * @returns {string} activeTab - 当前激活的面板 (balance/points)
     * @returns {Array} data - 余额交易明细列表
     * @returns {Array} pointsData - 积分交易明细列表
     * @returns {boolean} listShow - 余额列表是否显示空状态
     * @returns {boolean} pointsListShow - 积分列表是否显示空状态
     * @returns {number|string} funds - 账户余额
     * @returns {number|string} points - 积分余额
     * @returns {string} userName - 用户名
     */
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            activeTab: 'balance',
            data: [],
            pointsData: [],
            listShow: false,
            pointsListShow: false,
            funds: 0,
            points: 0,
            userName: ''
        };
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        this.loadData();
    },
    methods: {
        /**
         * 切换面板
         * @param {string} tab - 面板类型 (balance/points)
         */
        switchTab(tab) {
            this.activeTab = tab;
            if (tab === 'points' && this.pointsData.length === 0) {
                this.loadPointsData();
            }
        },
        /**
         * 加载钱包数据
         * 获取账户余额、积分和交易明细
         */
        loadData() {
            // 加载余额明细
            Fetch('/user/funds').then(r => {
                this.showError(r.data.list.length);
                this.data = r.data.list;
                this.funds = r.data.money;
                this.points = r.data.integral;
                this.userName = r.data.username;
            });

            // 加载积分数据
            this.loadPointsData();
        },
        /**
         * 加载积分数据
         * 获取积分余额和积分明细
         */
        loadPointsData() {
            Fetch('/user/points').then(r => {
                if (r.code === 1) {
                    this.pointsData = r.data.list || [];
                    this.points = r.data.integral || 0;
                    this.pointsListShow = this.pointsData.length === 0;
                }
            }).catch(() => {
                this.pointsListShow = true;
            });
        },
        /**
         * 按类型筛选交易明细
         * @param {number} val - 类型ID，0为全部
         */
        chooseType(val) {
            const params = val == 0 ? {} : { reason_id: val };
            Fetch('/user/funds', params).then(r => {
                this.data = r.data.list;
                this.showError(r.data.list.length);
            });
        },
        /**
         * 显示/隐藏空状态
         * @param {number} len - 列表长度
         */
        showError(len) {
            this.listShow = len == 0;
        }
    }
};
</script>

<style lang="less" scoped>
/**
 * 我的钱包页面样式
 * 采用卡片式设计，与其他页面保持一致的视觉风格
 */
.moneybag_wrap {
    min-height: 100vh;
    background-color: #f5f5f5;
    padding-bottom: 20px;
}

/* 顶部背景 */
.red_top_bg {
    height: 168px;
    background-image: url(../images/user/moneybag/bg.png);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

/* 余额卡片 */
.balance_card {
    position: relative;
    margin-top: 74px;
    margin-left: 15px;
    margin-right: 15px;
    background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
    border-radius: 12px;
    padding: 25px 20px;
    box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
    z-index: 11;

    /* 余额和积分信息 */
    .balance_info {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 25px;

        .balance_item {
            flex: 1;
            text-align: center;

            .balance_label {
                font-size: 13px;
                color: rgba(255, 255, 255, 0.8);
                margin-bottom: 10px;
            }

            .balance_value {
                font-size: 28px;
                font-weight: bold;
                color: #fff;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

                &.points {
                    font-size: 24px;
                }
            }
        }

        .balance_divider {
            width: 1px;
            height: 50px;
            background: rgba(255, 255, 255, 0.3);
            margin: 0 15px;
        }
    }

    /* 操作按钮 */
    .action_btns {
        display: flex;
        justify-content: center;
        gap: 20px;

        .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 30px;
            border-radius: 25px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:active {
                transform: scale(0.95);
            }

            .van-icon {
                font-size: 16px;
                margin-right: 6px;
            }

            span {
                font-size: 14px;
                font-weight: 500;
            }

            &.recharge {
                background: rgba(255, 255, 255, 0.9);
                color: #ff5252;
            }

            &.withdraw {
                background: rgba(255, 255, 255, 0.2);
                color: #fff;
                border: 1px solid rgba(255, 255, 255, 0.5);
            }
        }
    }
}

/* 交易明细区域 */
.detail_section {
    margin: 20px 15px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    overflow: hidden;
}

/* 面板切换 */
.tab_header {
    display: flex;
    background: #f5f5f5;
    margin: 10px 15px;
    border-radius: 8px;
    padding: 4px;

    .tab_item {
        flex: 1;
        text-align: center;
        padding: 10px 0;
        font-size: 14px;
        color: #666;
        cursor: pointer;
        border-radius: 6px;
        transition: all 0.3s ease;

        &.active {
            background: #fff;
            color: #ff5252;
            font-weight: 600;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }
    }
}

/* 明细列表 */
.detail_list {
    .detail_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        border-bottom: 1px solid #f5f5f5;
        transition: background 0.2s;

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            background: #f9f9f9;
        }

        .item_left {
            display: flex;
            align-items: center;
            flex: 1;

            .item_icon {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;

                .van-icon {
                    font-size: 18px;
                    color: #fff;
                }

                &.income {
                    background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
                }

                &.expense {
                    background: linear-gradient(135deg, #4ecdc4 0%, #44bd64 100%);
                }

                &.points_icon {
                    background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
                }
            }

            .item_info {
                .item_title {
                    font-size: 14px;
                    color: #333;
                    font-weight: 500;
                    margin-bottom: 4px;
                }

                .item_time {
                    font-size: 12px;
                    color: #999;
                }
            }
        }

        .item_amount {
            font-size: 16px;
            font-weight: 600;

            &.income {
                color: #ff5252;
            }

            &.expense {
                color: #44bd64;
            }
        }
    }
}
</style>
